// API Constants for Backend Communication
export const ApiConstants = {
    baseUrl: 'https://www.whysocial.in/clap-kartel/public',

    // Endpoints
    sendOtp: '/auth/send-otp',
    verifyOtp: '/auth/verifyotp',
    login: '/auth/login',
    loginWithPassword: '/auth/login_withpwd',
};
